/* eslint-disable jira/filename-case */

import React, { useState, useEffect } from 'react';

import { withRouter } from '@atlassian/react-resource-router';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fetchApplinks } from './fetchApplinkManifestForUrl.tsx';
import type { ApplicationLinkV3Data } from './CommonApplicationLinkCreationEntity.tsx';
import ApplinksPageContents from './ApplinksPageContents.tsx';

export const ApplinksPage = (): React.JSX.Element => {
	const [applinks, setApplinks] = useState<ApplicationLinkV3Data[] | null>(null);

	useEffect(() => {
		fetchApplinks()
			.then((data) => {
				setApplinks(data);
			})
			.catch((err) => {
				const maybeError = err instanceof Error ? err : undefined;
				log.safeErrorWithoutCustomerData(
					'applinks.administration.list.loadApplinks',
					'Failed to load applinks for the list page',
					maybeError,
				);
				setApplinks(null);
			});
	}, []);

	return <ApplinksPageContents applinks={applinks} />;
};

const List: {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<string, any>): React.JSX.Element;
	displayName: string;
} = withRouter(ApplinksPage);

export default List;
